module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Join-3-82b513acd628753c5c8a230531a58b5b8c7b993f22d8a07852aec4297d9768c7.svg";